import Vue from 'vue'
import VueRouter from 'vue-router'
import Auth from '../views/Auth.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Auth',
    component: Auth
  },
  {
    path: '/platform/cotizador',
    name: 'Cotizador',
    component: () => import('../views/Cotizador.vue'),
  },
  {
    path: '/platform/cotizaciones',
    name: 'Cotizaciones',
    component: () => import('../views/Cotizaciones.vue'),
  },
  {
    path: '/platform/cotizacion/:id',
    name: 'Cotizacion',
    component: () => import('../views/Cotizacion.vue'),
  },
  {
    path: '/platform/productos',
    name: 'Productos',
    component: () => import('../views/Productos.vue'),
  },
  {
    path: '/platform/productos/importacion-metalicos',
    name: 'ImportacionMetalicos',
    component: () => import('../views/ImportacionMetalicos.vue'),
  },
  {
    path: '/platform/productos/importacion-panel-ternium',
    name: 'ImportacionPanelTernium',
    component: () => import('../views/ImportacionPanelTernium.vue'),
  },
  {
    path: '/platform/productos/importacion-panel-isocindu',
    name: 'ImportacionIsocindu',
    component: () => import('../views/ImportacionIsocindu.vue'),
  },
  {
    path: '/platform/productos/importacion-otros',
    name: 'ImportacionOtros',
    component: () => import('../views/ImportacionOtros.vue'),
  },
  {
    path: '/platform/familias',
    name: 'Familias',
    component: () => import('../views/Familias.vue'),
  },
  {
    path: '/platform/destinos',
    name: 'Destinos',
    component: () => import('../views/Destinos.vue'),
  },
  {
    path: '/platform/destinos/importacion-destinos',
    name: 'ImportacionDestinos',
    component: () => import('../views/ImportacionDestinos.vue'),
  },
  {
    path: '/platform/clientes',
    name: 'Clientes',
    component: () => import('../views/Clientes.vue'),
  },
  {
    path: '/platform/clientes/nuevo-cliente',
    name: 'NuevoCliente',
    component: () => import('../views/NuevoCliente.vue'),
  },
  {
    path: '/platform/clientes/importacion-clientes',
    name: 'ImportacionClientes',
    component: () => import('../views/ImportacionClientes.vue'),
  },
  {
    path: '/platform/clientes/:id',
    name: 'Cliente',
    component: () => import('../views/Cliente.vue'),
  },
  {
    path: '/platform/servicios',
    name: 'Servicios',
    component: () => import('../views/Servicios.vue'),
  },
  {
    path: '/platform/servicios/importacion-servicios',
    name: 'ImportacionServicios',
    component: () => import('../views/ImportacionServicios.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
